export const roles = [
  'Admin',  "Supervisor", 
  "Reporter",  // This role can post to any category
  "Any",  //used only for category, any roles can post on this category
  'None', //used only for category, no roles except article manager can post on this category
  'NCKH GV 1',  'NCKH GV 2',  'NCKH GV 3',
  'NCKH SV 1',  'NCKH SV 2',  'NCKH SV 3',
  'HTQT 1',  'HTQT 2',  'HTQT 3',
  'HTTN 1',  'HTTN 2',  'HTTN 3',
  'KHAC 1',  'KHAC 2',  'THONG BAO',  
];
const AMROLES = [1, 2, 3];
const CMROLES = [1,2];
const TBROLES = [20];

export const isAny = 4;
export const isNone = 5;

export const isAdmin = role => role && (role.indexOf(1) > -1);
export const isSupervisor = role => role  && role.indexOf(2) > -1;
export const isReporter = role => role && role.indexOf(3) > -1;
export const isArticleManager = role => role && (isAdmin(role) || isSupervisor(role));
export const isAnnouncer = role => role && ((role.indexOf(20) > -1) || isAdmin(role) ||  isSupervisor(role));

export const roleToString = (role) => roles[role - 1];

export const rolesToString = (r) => r.map(role => roleToString(role)).join(', ');

export const rolesToStrings = (r) => r.map(role => roleToString(role));

export const stringToRole = (string) => roles.findIndex(i => i === string) + 1;

export const stringsToRoles = (strings) => strings.map(string => stringToRole(string.trim())).sort();



// WEBPACK FOOTER //
// ./src/utils/roles.js